import React from "react";
import Image from "next/image";
import Link from "next/link";

export const NewsCard = ({
    image,
    date,
    title,
    link,
    slug,
    boxShadow = true,
    doc,
}) => {
    // Priority: detail page (slug) -> external link -> PDF (legacy fallback)
    const href = slug
        ? `/news-release/${slug}`
        : link
        ? link
        : doc
        ? doc
        : "#";
    const isInternal = Boolean(slug);

    return (
        <Link
            href={href}
            target={isInternal ? undefined : "_blank"}
            rel={isInternal ? undefined : "noopener noreferrer"}
            className={`rounded-[15px] ${
                boxShadow ? "news-card" : ""
            } h-full bg-white flex flex-col justify-between overflow-hidden`}
        >
            <div className="flex flex-col gap-4 items-start p-8">
                <span className="text-[14px] lg:text-[16px] xl:text-[18px]  font-normal text-[#888888]">
                    {date}
                </span>
                <h3 className="text-[14px] md:text-[16px] lg:text-[26px] font-normal leading-[24px] lg:leading-[36px] xl:leading-[36px]">
                    {title}
                </h3>
            </div>
            <div className="max-h-[250px] flex-grow ">
                {image ? (
                    <Image
                        alt={title || "Hindustan Power news release"}
                        src={image}
                        width={30}
                        height={30}
                        unoptimized
                        className="object-cover w-full h-[250px]"
                    />
                ) : (
                    <></>
                )}
            </div>
        </Link>
    );
};
